"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Asterisk } from "lucide-react";

const industries = [
    "Agriculture",
    "Commercial Farming",
    "Construction",
    "Water Supply",
    "Manufacturing",
    "Commercial & Industrial",
    "Hospitality",
    "Education",
    "Healthcare",
    "Property Development",
    "Landscaping",
    "Retail",
    "Government",
    "Homes & Institutions",
];

export default function PotentialClients() {
    return (
        <div className="flex flex-col items-center justify-center w-full bg-primary text-white">
            <div className="flex justify-center md:py-6 md:mt-4 w-full border-y border-grey/40">
                <p className="md:text-2xl md:max-w-3xl text-center font-normal">
                    The work may be different, but the need for reliable equipment isn't. We proudly support sectors that keep Kenya moving.
                </p>
            </div>
            <div className="relative flex justify-center md:py-8 w-full overflow-hidden">
                {/* edge fade overlays */}
                <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-16 md:w-40 bg-gradient-to-r from-primary to-transparent" />
                <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-16 md:w-40 bg-gradient-to-l from-primary to-transparent" />

                <div className="w-full">
                    <Swiper
                        modules={[Autoplay]}
                        loop={true}
                        speed={8000}
                        allowTouchMove={false}
                        autoplay={{
                            delay: 0,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            320: {
                                slidesPerView: 2,
                                spaceBetween: 32,
                            },
                            640: {
                                slidesPerView: 3,
                                spaceBetween: 48,
                            },
                            768: {
                                slidesPerView: 4,
                                spaceBetween: 56,
                            },
                            1024: {
                                slidesPerView: 6,
                                spaceBetween: 64,
                            },
                            1440: {
                                slidesPerView: 7,
                                spaceBetween: 72,
                            },
                        }}
                    >
                        {industries.map((client, i) => (
                            <SwiperSlide key={i} className="!w-auto">
                                <div className="flex shrink-0 items-center gap-6 md:gap-8">
                                    <p className="whitespace-nowrap text-sm font-medium uppercase tracking-widest text-white transition-colors hover:text-white md:text-base">
                                        {client}
                                    </p>
                                    <Asterisk
                                        className="h-5 w-5 shrink-0 fill-secondary text-secondary"
                                        // strokeWidth={1.5}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}